export const CustomerData = {
    name: "",
    contactNumber: 0,
    email: "",
    status: "",
    joinDate: "",
    emailVerification: false,
    mobileVerification: false,
    address: []
}